import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f163e83e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column" }
const _hoisted_2 = { class: "flex align-items-center justify-content-center" }
const _hoisted_3 = { class: "flex align-items-center justify-content-center font-bold p-2" }
const _hoisted_4 = { class: "flex align-items-center justify-content-center" }
const _hoisted_5 = { class: "text-primary font-bold" }
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = {
  key: 1,
  class: "ml-auto border-1 surface-border border-round surface-100 text-xs p-1"
}
const _hoisted_8 = { class: "flex align-items-center justify-content-center" }
const _hoisted_9 = { class: "flex align-items-center justify-content-center mr-2" }
const _hoisted_10 = { class: "flex align-items-center justify-content-center mr-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx, _cache) {
  const _component_p_avatar = _resolveComponent("p-avatar")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_p_badge = _resolveComponent("p-badge")
  const _component_router_link = _resolveComponent("router-link")
  const _component_p_button = _resolveComponent("p-button")
  const _component_p_menu = _resolveComponent("p-menu")
  const _directive_ripple = _resolveDirective("ripple")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_p_avatar, {
      image: _ctx.user.photo_thum,
      icon: !_ctx.user.photo_thum ?  'pi pi-user' : '',
      shape: "circle",
      style: {"background-color":"#2196f3","color":"#ffffff"},
      type: "button",
      onClick: _ctx.toggle,
      "aria-haspopup": "true",
      "aria-controls": "overlay_menu"
    }, null, 8, ["image", "icon", "onClick"]),
    _createVNode(_component_p_menu, {
      class: "md:w-15rem",
      ref: "menu",
      id: "overlay_menu",
      model: _ctx.items,
      popup: true
    }, {
      start: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_p_avatar, {
              image: _ctx.user.photo_thum,
              icon: !_ctx.user.photo_thum ?  'pi pi-user' : '',
              shape: "circle",
              style: {"background-color":"#2196f3","color":"#ffffff"},
              size: "xlarge"
            }, null, 8, ["image", "icon"])
          ]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.user.name), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("i", null, _toDisplayString(_ctx.user.email), 1)
          ])
        ])
      ]),
      submenuheader: _withCtx(({ item }) => [
        _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1)
      ]),
      item: _withCtx(({ item, props }) => [
        _withDirectives((_openBlock(), _createBlock(_component_router_link, _mergeProps({
          to: item.to ?  item.to : '',
          class: "flex align-items-center"
        }, props.action), {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: item.icon
            }, null, 8, ["icon"]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1),
            (item.badge)
              ? (_openBlock(), _createBlock(_component_p_badge, {
                  key: 0,
                  class: "ml-auto",
                  value: item.badge
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            (item.shortcut)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.shortcut), 1))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1040, ["to"])), [
          [_directive_ripple]
        ])
      ]),
      end: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_p_button, {
              disabled: _ctx.is_loading,
              icon: _ctx.is_loading ? 'pi pi-spin pi-cog' : (_ctx.checkDark ? 'pi pi-moon':'pi pi-sun'),
              onClick: _ctx.changeDark,
              rounded: "",
              outlined: ""
            }, null, 8, ["disabled", "icon", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_p_button, {
              disabled: _ctx.is_loading,
              icon: _ctx.is_loading ? 'pi pi-spin pi-cog' : (_ctx.checkMode === 'static' ? 'pi pi-list':'pi pi-stop'),
              onClick: _ctx.changeMode,
              rounded: "",
              outlined: ""
            }, null, 8, ["disabled", "icon", "onClick"])
          ])
        ]),
        _hoisted_11,
        _createVNode(_component_p_button, {
          onClick: _ctx.onLogout,
          label: "LOGOUT",
          icon: "pi pi-sign-out",
          severity: "danger",
          class: "w-full flex align-items-center"
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["model"])
  ], 64))
}